import React, { useEffect } from 'react';

const containerStyle = {
  minHeight: '100vh',
  display: 'grid',
  placeItems: 'center',
  padding: '24px',
  background: '#f6f6f3',
  color: '#0a0a0a',
  fontFamily: 'Inter, system-ui, sans-serif',
};

const cardStyle = {
  width: 'min(640px, 100%)',
  background: '#ffffff',
  border: '1px solid rgba(10, 10, 10, 0.12)',
  padding: '28px 24px',
  boxShadow: '0 18px 50px rgba(0, 0, 0, 0.08)',
};

const overlineStyle = {
  margin: 0,
  marginBottom: '10px',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.18em',
  textTransform: 'uppercase',
  color: '#4a4a4a',
};

const titleStyle = {
  margin: 0,
  marginBottom: '12px',
  fontFamily: '"Cormorant Garamond", Georgia, serif',
  fontSize: '42px',
  lineHeight: 1.02,
  fontWeight: 500,
};

const bodyStyle = {
  margin: 0,
  marginBottom: '16px',
  fontSize: '15px',
  lineHeight: 1.55,
  color: '#2b2b2b',
};

const noteStyle = {
  margin: 0,
  fontSize: '13px',
  lineHeight: 1.45,
  color: '#5a5a5a',
};

const detailsBoxStyle = {
  marginTop: '6px',
  padding: '14px 16px',
  border: '1px solid rgba(10, 10, 10, 0.1)',
  background: '#fafaf8',
};

const detailsLineStyle = {
  margin: 0,
  fontSize: '14px',
  lineHeight: 1.55,
  color: '#2b2b2b',
};

const buttonStyle = {
  marginTop: '16px',
  minHeight: '42px',
  padding: '10px 14px',
  border: '1px solid #0a0a0a',
  background: '#0a0a0a',
  color: '#fff',
  fontSize: '11px',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase',
  cursor: 'pointer',
};

const WebinarThankYouPage = () => {
  useEffect(() => {
    document.title = 'Thank You | Douglas & McCartney Webinar';
  }, []);

  return (
    <div style={containerStyle}>
      <div style={cardStyle}>
        <p style={overlineStyle}>Thank You</p>
        <h1 style={titleStyle}>Registration Successful.</h1>
        <p style={bodyStyle}>
          Thank you for registering.
        </p>
        <p style={bodyStyle}>
          You have also requested access to the exclusive private webinar where Dr. Pounacha will explain how real estate professionals are building stronger personal brands, attracting better clients, and creating predictable income.
        </p>
        <div style={detailsBoxStyle}>
          <p style={detailsLineStyle}><strong>Webinar Date:</strong> Based on your selected slot</p>
          <p style={detailsLineStyle}><strong>Duration:</strong> 1 Hour</p>
          <p style={detailsLineStyle}><strong>Access link:</strong> will be sent to the Email ID before the session.</p>
        </div>
        <p style={{ ...noteStyle, marginTop: '8px' }}>
          You can close this tab and continue.
        </p>
        <button type="button" style={buttonStyle} onClick={() => window.close()}>
          Close Tab
        </button>
      </div>
    </div>
  );
};

export default WebinarThankYouPage;
